import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MasterCard from "examples/Cards/MasterCard";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

import DataTable from "examples/Tables/DataTable";

import team3 from "assets/images/team-3.jpg";

import MDActionConfigurator from "components/MDActionConfigurator";

import {
  getTransactionList,
  getStatsTransactions,
  getIncompleteTransactions,
  newTransactionCreate,
  updatingTransaction,
} from "actions/transactionActions";
import { getPaymentInfo } from "actions/infoActions";
import { getClientList } from "actions/clientActions";
import { getOrderList } from "actions/orderActions";
import MDButton from "components/MDButton";

function Transactions() {
  const dispatch = useDispatch();
  const configuratorRef = useRef(null);
  const [currentInfo, setCurrentInfo] = useState(null);
  const [selectClient, setSelectClient] = useState([]);
  const [selectOrder, setSelectOrder] = useState([]);
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    transactionCode: "",
    client: "",
    order: "",
    transactionMethod: "",
    amount: "",
  });

  const listClients = useSelector((state) => state.listClients);
  const { clientsList } = listClients;

  const listOrders = useSelector((state) => state.listOrders);
  const { ordersList } = listOrders;

  const statsTransactions = useSelector((state) => state.statsTransactions);
  const { transactionsStats } = statsTransactions;

  const paymentInfo = useSelector((state) => state.paymentInfo);
  const { info } = paymentInfo;

  const listTransactions = useSelector((state) => state.listTransactions);
  const { transactionsList } = listTransactions;

  const incompleteTransactions = useSelector(
    (state) => state.incompleteTransactions
  );
  const { transactionsIncomplete } = incompleteTransactions;

  useEffect(() => {
    if (transactionsIncomplete?.length === 0) {
      dispatch(getIncompleteTransactions());
    }
  }, [dispatch, transactionsIncomplete?.length]);

  useEffect(() => {
    dispatch(getPaymentInfo());
  }, [dispatch]);

  useEffect(() => {
    if (info?.length) {
      setCurrentInfo(info[0]);
    }
  }, [info?.length]);

  const handleCurrentInfo = (item) => {
    info?.map((val) => {
      if (val.method === item) {
        setCurrentInfo(val);
      }
    });
  };

  useEffect(() => {
    if (transactionsStats?.length === 0) {
      dispatch(getStatsTransactions());
    }
  }, [dispatch, transactionsStats?.length]);

  useEffect(() => {
    if (transactionsList?.length === 0) {
      dispatch(getTransactionList());
    }
  }, [dispatch, transactionsList?.length]);

  useEffect(() => {
    if (clientsList?.length === 0) {
      dispatch(getClientList());
    }
    setSelectClient(
      clientsList?.map((item) => ({
        value: item._id,
        name: item.name,
      }))
    );
  }, [dispatch, clientsList?.length]);

  useEffect(() => {
    if (ordersList?.length === 0) {
      dispatch(getOrderList());
    }
    setSelectOrder(
      ordersList?.map((item) => ({
        value: item._id,
        name: item._id + " - " + item.product?.productName,
      }))
    );
  }, [dispatch, ordersList?.length]);

  const selectTransactionMethod = [
    {
      name: "MPESA",
      value: "MPESA",
    },
  ];

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitTransaction = (e) => {
    if (currentState === "edit") {
      dispatch(updatingTransaction(currentData?._id, e));
    } else {
      dispatch(newTransactionCreate(e));
    }
    handleToggleBackdrop({}, "");
  };

  const Supplier = ({ image, name, date }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox display="flex" flexDirection="column">
        <MDTypography
          variant="button"
          fontWeight="medium"
          ml={1}
          mb={1}
          lineHeight={1}
        >
          {name}
        </MDTypography>
        <MDTypography
          variant="button"
          fontWeight="normal"
          color="text"
          ml={1}
          lineHeight={1}
        >
          {moment(date).fromNow()}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        transactionCode: (
          <Link to={`/transactions/${item?._id}`}>
            <Supplier
              key={index}
              image={team3}
              name={item?.transactionCode}
              date={item?.updated_at}
            />
          </Link>
        ),
        client: (
          <Link to={`/transactions/${item?._id}`}>
            <MDBox display="flex" flexDirection="column">
              <MDTypography
                variant="caption"
                color="text"
                fontWeight="medium"
                mb={1}
              >
                {item?.client?.name}
              </MDTypography>
              <MDTypography variant="caption" color="text" fontWeight="normal">
                {item?.client?.email}
              </MDTypography>
            </MDBox>
          </Link>
        ),
        order: (
          <Link to={`/orders/${item?.order?._id}`}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.order?._id}
            </MDTypography>
          </Link>
        ),
        amount: (
          <MDBox display="flex" flexDirection="column">
            <MDTypography
              variant="caption"
              color="text"
              fontWeight="medium"
              mb={1}
            >
              {item?.amount}
            </MDTypography>
            <MDTypography variant="caption" color="text" fontWeight="normal">
              {item?.transactionMethod}
            </MDTypography>
          </MDBox>
        ),
        status: (
          <MDBox width="8rem" textAlign="center">
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={item?.status}
                color={
                  item?.status == "pending"
                    ? "info"
                    : item?.status == "processing"
                    ? "primary"
                    : item?.status == "approved"
                    ? "success"
                    : item?.status == "rejected"
                    ? "dark"
                    : "light"
                }
                variant="gradient"
                size="sm"
              />
            </MDBox>
          </MDBox>
        ),
      };

      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} xl={4}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="info"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("MPESA")}
                      >
                        &nbsp;MPESA
                      </MDButton>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="info"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("CHEQUE")}
                      >
                        &nbsp;CHEQUE
                      </MDButton>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="info"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("BANK TRANSFER")}
                      >
                        &nbsp;TRANSFER
                      </MDButton>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <MDButton
                        component="a"
                        href="#"
                        rel="noreferrer"
                        variant="gradient"
                        color="info"
                        sx={{ width: "100%" }}
                        onClick={() => handleCurrentInfo("FINANCING")}
                      >
                        &nbsp;CREDIT
                      </MDButton>
                    </Grid>
                  </Grid>
                  <MasterCard currentInfo={currentInfo} />
                </Grid>
                {transactionsStats?.map((item, index) => (
                  <Grid key={index} item xs={12} md={2} xl={2}>
                    <DefaultInfoCard
                      icon={
                        item?.statuses?.status == "pending"
                          ? "priority_high"
                          : item?.statuses?.status == "processing"
                          ? "hourglass_bottom"
                          : item?.statuses?.status == "completed"
                          ? "done"
                          : "clear"
                      }
                      title={
                        item?.statuses?.status == "pending"
                          ? "Pending Transactions"
                          : item?.statuses?.status == "processing"
                          ? "Processing Transactions"
                          : item?.statuses?.status == "completed"
                          ? "Completed Transactions"
                          : "Rejected Transactions"
                      }
                      color={
                        item?.statuses?.status == "pending"
                          ? "info"
                          : item?.statuses?.status == "processing"
                          ? "primary"
                          : item?.statuses?.status == "completed"
                          ? "success"
                          : "dark"
                      }
                      description={
                        "Percentage: " +
                        (item?.statuses?.percentage).toFixed(1) +
                        "% of " +
                        item?.totalCount +
                        " payments"
                      }
                      value={item?.statuses?.count}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card id="delete-account">
                <MDBox pt={3} px={2}>
                  <MDTypography variant="body2" fontWeight="small" mb={2}>
                    # To make a new transaction manually, start selection from
                    desired order.
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="medium">
                    Transactions
                  </MDTypography>
                </MDBox>

                <MDBox
                  display="flex"
                  alignItems="center"
                  lineHeight={0}
                ></MDBox>
                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Transaction Code",
                          accessor: "transactionCode",
                          width: "20%",
                          align: "left",
                        },
                        {
                          Header: "client",
                          accessor: "client",
                          width: "20%",
                          align: "left",
                        },
                        {
                          Header: "order",
                          accessor: "order",
                          width: "20%",
                          align: "left",
                        },
                        {
                          Header: "amount",
                          accessor: "amount",
                          width: "20%",
                          align: "center",
                        },

                        {
                          Header: "status",
                          accessor: "status",
                          width: "20%",
                          align: "center",
                        },
                      ],

                      rows: renderRows(transactionsList),
                    }}
                    showTotalEntries={false}
                    isSorted={false}
                    noEndBorder
                    entriesPerPage={false}
                  />
                </MDBox>
              </Card>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card sx={{ height: "100%" }}>
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  pt={3}
                  px={2}
                >
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    textTransform="capitalize"
                  >
                    Incomplete Customer Transactions
                  </MDTypography>
                  <MDBox display="flex" alignItems="flex-start">
                    <MDBox color="text" mr={0.5} lineHeight={0}>
                      <Icon color="inherit" fontSize="small">
                        date_range
                      </Icon>
                    </MDBox>
                    <MDTypography
                      variant="button"
                      color="text"
                      fontWeight="regular"
                    >
                      {moment(new Date().getTime()).format("DD MMM YYYY")}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox pt={3} pb={2} px={2}>
                  <MDBox mb={2}>
                    <MDBox>
                      <DataTable
                        table={{
                          columns: [
                            {
                              Header: "client",
                              accessor: "client",
                              width: "45%",
                              align: "left",
                            },
                            {
                              Header: "amount",
                              accessor: "amount",
                              align: "center",
                            },
                            {
                              Header: "status",
                              accessor: "status",
                              align: "center",
                            },
                          ],

                          rows: renderRows(transactionsIncomplete),
                        }}
                        showTotalEntries={false}
                        isSorted={false}
                        noEndBorder
                        entriesPerPage={false}
                      />
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid> */}
          </Grid>
        </MDBox>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Transaction Config"
        onCompleteConfig={handleSubmitTransaction}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Transaction Code",
            placeholderType: "Select Transaction Code",
            dataType: "text",
            keyType: "transactionCode",
            valueType: currentData?.transactionCode,
          },
          {
            labelType: "Client",
            placeholderType: "Select Client",
            dataType: "select",
            keyType: "client",
            valueType: currentData?.client?._id,
            options: selectClient,
          },
          {
            labelType: "Order",
            placeholderType: "Select Order",
            dataType: "select",
            keyType: "order",
            valueType: currentData?.order?._id,
            options: selectOrder,
          },
          {
            labelType: "Transaction Method",
            placeholderType: "Select Transaction Method",
            dataType: "select",
            keyType: "transactionMethod",
            valueType: currentData?.transactionMethod,
            options: selectTransactionMethod,
          },
          {
            labelType: "Amount",
            placeholderType: "Enter Amount",
            dataType: "number",
            keyType: "amount",
            valueType: currentData?.amount,
          },
        ]}
        state={currentState}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Transactions;
